import React from "react";
import { motion } from "framer-motion";
import styles from "./css/Profile.module.css";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const initials = user.name ? user.name.slice(0, 2).toUpperCase() : "US";

  return (
    <div className={styles.profileContainer}>
      <motion.div
        className={styles.profileCard}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 100, damping: 15 }}
      >
        <div className={styles.profileHeader}>
          <div className={styles.avatarCircle}>{initials}</div>
          <h4 className={styles.userName}>{user.name || "Merchant User"}</h4>
          <span className={styles.userIdBadge}>ID: {user.userId || "N/A"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>
            <i className="fas fa-id-badge"></i> User ID
          </span>
          <span className={styles.infoValue}>{user.userId || "-"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>
            <i className="fas fa-user"></i> Full Name
          </span>
          <span className={styles.infoValue}>{user.name || "-"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>
            <i className="fas fa-envelope"></i> Email Address
          </span>
          <span className={styles.infoValue}>{user.email || "-"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>
            <i className="fas fa-phone"></i> Phone Number
          </span>
          <span className={styles.infoValue}>{user.phonenumber || "-"}</span>
        </div>
      </motion.div>
    </div>
  );
};

export default Profile;
